import { EncounterType } from './types/encounterTypes';

export function getEmptyEncounter(company?: string, centerId?: string): EncounterType {
  return {
    caseIdentification: {
      company: company || '',
      centerId: centerId || '',
      accountNumber: '',
      visitNumber: undefined,
      visitKey: '',
      caseNumber: '',
      externalId: '',
      id: '',
    },
    status: 'SCHED',
    encounterInfo: { visitNumber: 0 },
    patient: { firstName: '', lastName: '', mrn: '' },
    physician: {},
    guarantor: {},
    procedures: [],
    insurances: [],
    visitNotes: [],
    scheduledProcedureCodes: [],
    id: '',
  };
}
